export default __webpack_public_path__ + "static/jonghyeon.jeong-033bfaf942b4387dc2246686227550fe.png";